import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projets`}</h2>
    <ProjectCard title="Showreel & animation" link="https://isofju.notion.site/Animation-short-films-50495c1aa9354a4c95990f21bf241464" bg="#7771" mdxType="ProjectCard">
  🎞️
    </ProjectCard>
    <ProjectCard title="Concept Art" link="https://isofju.artstation.com/" bg="#7771" mdxType="ProjectCard">
  🖼️
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      